// §4.4 partial — admin/integrations routes.
// Composer auto-collects this into routes.generated.ts.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

// TODO(refactor-admin): split Integracoes into WhatsApp/Voxuy/Doppler
// subpages, move PWA toggles into Integracoes, and keep Notificacoes
// (in-app history) separate from Alertas (send rules).
const IntegrationsPage = lazyWithRetry(
  () => import("./pages/IntegrationsPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [{ path: "/admin/integrations", Component: IntegrationsPage }],
  },
];

export default routes;
